import Symbol           from 'es6-symbol/polyfill';
import EventEmitter     from 'events';
import axios            from 'axios';

let singleton = Symbol();
let singletonEnforcer = Symbol();

class UsersService extends EventEmitter {

  //________________________________________________________ constructor
  // -
  constructor(pEnforcer) {
    if (pEnforcer !== singletonEnforcer) {
      throw 'Cannot construct singleton';
    }
    super();
    this._countries = [];
    this._provinces = [];
    this._isConnected = false;
  }

  static getInstance() {
    if (!this[singleton]) {
      this[singleton] = new UsersService(singletonEnforcer);
    }
    return this[singleton];
  }

  get isConnected() {
    return this._isConnected;
  }

  get isValid() {
    if(this._currentUser.email && this._currentUser.firstName && this._currentUser.lastName) {
      return true;
    }
    return false;
  }

  get user() {
    return this._currentUser;
  }

  get countries() {
    return this._countries;
  }

  me() {
    const seq = axios.get('/api/v2/users/me');
    seq.then(res => {
      if(!res.data.roles?.includes('ROLE_GUEST')) {
        this._isConnected = true;
        this._currentUser = res.data;
        this.emit('updated', this._currentUser);
      }
    }).catch( (err) => {
      this._isConnected = false;
      this._currentUser = null;
      console.error(err);
    });
    return seq;
  }

  update(id, datas) {
    const seq = axios.patch(`/api/v2/users/${id}`, {...datas}, { headers: {
      'Content-Type': 'application/merge-patch+json'
    }});
    seq.then( res => {
      this._currentUser = res.data;
      this.emit('updated', this._currentUser);
    }).catch( console.error );
    return seq;
  }

  getCountries() {
    const seq = axios.get(`/api/v2/shippings/countries`);
    seq.then(res => {
      this._countries = res.data['hydra:member'];
      this.emit('countries', this._countries);
    }).catch( console.error );
    return seq;
  }

  getCountry(code) {
    if (!this._countries) return null;
    for( let i = 0; i < this._countries.length; i++) {
      const country = this._countries[i];
      if (country.code === code) return country;
    }
  }

  getProvinces(id) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v2/countries/${id}/provinces`).then(res => {
        resolve(res.data['hydra:member']);
      }).catch(reject);
    })
  }

  addAddress(datas) {
    const seq = axios.post(`/api/v2/addresses`, {...datas});
    seq.catch( console.error );
    return seq;
  }

  updateAddress(id, datas) {
    const seq = axios.patch(`/api/v2/addresses/${id}`, {...datas}, { headers: {
      'Content-Type': 'application/merge-patch+json'
    }});
    seq.catch( console.error );
    return seq;
  }
}
export default UsersService.getInstance();
